// extracted by mini-css-extract-plugin
export default {"base":"Button_base__wb2g+","primary":"Button_primary__9MLUH","cancel":"Button_cancel__MOD8z"};